import { render, staticRenderFns } from "./manageclaimbatches.vue?vue&type=template&id=43ad1309&"
import script from "./manageclaimbatches.vue?vue&type=script&lang=js&"
export * from "./manageclaimbatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports